import { SystemLabel } from './system-label';

export class FeaturedSystemLabel extends SystemLabel {}
